import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import api from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email, origin: window.location.origin });
      setSent(true);
    } catch (e2) {
      const status = e2.response?.status;
      if (status === 200 || status === 404) {
        // Réponse ambiguë mais pas une vraie panne : on garde le message générique
        // anti-énumération plutôt que de confirmer/infirmer l'existence du compte.
        setSent(true);
      } else {
        setError("Une erreur est survenue, veuillez réessayer.");
      }
    } finally { setBusy(false); }
  };

  return (
    <main className="min-h-screen flex items-center justify-center p-8 beige-texture">
      <div className="w-full max-w-sm bg-sable rounded-2xl border border-marine/10 shadow-md p-10" data-testid="forgot-card">
        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-bordeaux mb-2">Mot de passe oublié</div>
        {sent ? (
          <div data-testid="forgot-sent">
            <MailCheck size={16} className="text-bleu mb-3" />
            <h1 className="font-display text-2xl text-marine mb-2">Vérifiez votre boîte mail</h1>
            <p className="text-sm text-marine/80">Si un compte est associé à <b>{email}</b>, un lien de réinitialisation (valable 1 heure) vient d'être envoyé.</p>
            <Link to="/login" className="inline-block mt-6 text-sm text-marine hover:underline">← Retour à la connexion</Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <h1 className="font-display text-3xl text-marine mb-3">Réinitialiser</h1>
            <p className="text-sm text-marine/80 mb-6">Saisissez votre e-mail : nous vous enverrons un lien pour choisir un nouveau mot de passe.</p>
            {error && <p data-testid="forgot-error" className="text-sm text-rouge bg-rouge-50 border border-rouge/30 rounded-sm px-3 py-2 mb-4">{error}</p>}
            <label htmlFor="forgot-email" className="block text-xs font-semibold uppercase tracking-wider text-marine/80 mb-1.5">Email</label>
            <input id="forgot-email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="inp mb-6" />
            <button data-testid="forgot-submit" disabled={busy} className="w-full bg-bordeaux text-white rounded-xl py-3 text-sm font-semibold hover:bg-bordeaux-hover transition-colors active:scale-95 flex items-center justify-center gap-2">
              {busy && <Loader2 size={16} className="animate-spin" />} Envoyer le lien
            </button>
            <Link to="/login" className="block mt-6 text-sm text-marine/80 hover:text-marine text-center">← Retour à la connexion</Link>
          </form>
        )}
      </div>
    </main>
  );
}
